import {
  SET_ISLOGIN,
  SET_REMEMBER_ME,
  SET_PERSIST_USERNAME,
  SET_PERSIST_PASSWORD,
  SET_DARK_THEME,
  SET_ROW_STATUS,
  SET_CURRENT_USER_DATA,
  SET_IS_MODAL_OPEN,
  SET_MODAL_DATA,
  SET_NAMING_PAGES,
  SET_DEPARTMENTSDATA,
  SET_USERS_DATA,
  SET_ROLES_DATA,
  SET_GROUPING_DATA,
  SET_ARTICLES_DATA,
  SET_NEWS_DATA,
  SET_PROJECTS_DATA,
  SET_FAQ_DATA,
  SET_TOKEN_NEEDED,
} from "../actions/global-state-actions";
import importAllPages from "../../utils/import-all-pages";

export interface GlobalStateProps {
  isLogined: boolean | any;
  rememberMe: boolean | any;
  theme?: string;
  persistUsername: string;
  persistPassword: string;
  rowStatus: { status: boolean; id: string };
  currentUserData: any;
  isModalOpen: boolean;
  modalData: { title: string; message: string; buttonText: string };
  urlOfPages?: any;
  departmentsData: [] | any;
  usersData: [] | any;
  rolesData: [] | any;
  groupingData: [] | any;
  articlesData: [] | any;
  newsData: [] | any;
  projectsData: [] | any;
  faqData: [] | any;
  newTokenNeeded: boolean;
  catalog: any;
}

const pages = importAllPages(
  require.context("../../pages", true, /\.(tsx|jsx|ts|js)$/)
);

const initialState: GlobalStateProps = {
  isLogined: false,
  rememberMe: false,
  theme: "light",
  persistUsername: "",
  persistPassword: "",
  rowStatus: { status: false, id: "" },
  currentUserData: "",
  isModalOpen: false,
  modalData: {
    title: "Notification",
    message: "are you sure??",
    buttonText: "confirm",
  },
  urlOfPages: Object.keys(pages)
    .filter(
      (page) =>
        page !== "login-page" &&
        page !== "register-page" &&
        page !== "forgot-password" &&
        page !== "naming-pages"
    )
    .map((page) => ({
      url: `/${page}`,
      persianName: "",
    })),
  departmentsData: [],
  usersData: [],
  rolesData: [],
  groupingData: [],
  articlesData: [],
  newsData: [],
  projectsData: [],
  faqData: [],
  newTokenNeeded: false,
  catalog: [],
};

export const globalStateReducer = (
  state: GlobalStateProps = initialState,
  action: any
): GlobalStateProps => {
  switch (action.type) {
    case SET_ISLOGIN:
      return { ...state, isLogined: action.payload };

    case SET_REMEMBER_ME:
      return { ...state, rememberMe: action.payload };

    case SET_PERSIST_USERNAME:
      return { ...state, persistUsername: action.payload };

    case SET_PERSIST_PASSWORD:
      return { ...state, persistPassword: action.payload };

    case SET_DARK_THEME:
      return { ...state, theme: action.payload };
    case SET_ROW_STATUS:
      return { ...state, rowStatus: action.payload };

    case SET_CURRENT_USER_DATA:
      return { ...state, currentUserData: action.payload };

    case SET_IS_MODAL_OPEN:
      return { ...state, isModalOpen: action.payload };

    case SET_MODAL_DATA:
      return { ...state, modalData: action.payload };

    case SET_NAMING_PAGES:
      return { ...state, urlOfPages: action.payload };

    case SET_DEPARTMENTSDATA:
      return { ...state, departmentsData: action.payload };

    case SET_USERS_DATA:
      return { ...state, usersData: action.payload };

    case SET_ROLES_DATA:
      return { ...state, rolesData: action.payload };

    case SET_GROUPING_DATA:
      return { ...state, groupingData: action.payload };

    case SET_ARTICLES_DATA:
      return { ...state, articlesData: action.payload };

    case SET_NEWS_DATA:
      return { ...state, newsData: action.payload };

    case SET_PROJECTS_DATA:
      return { ...state, projectsData: action.payload };

    case SET_FAQ_DATA:
      return { ...state, faqData: action.payload };

    case SET_TOKEN_NEEDED:
      return { ...state, newTokenNeeded: action.payload };

    default:
      return state;
  }
};
